<template>
  <resource-loader-controller :resource="listResource" v-slot="allProps">
    <search-filter
      :value="filters"
      :permanent="permanent"
      :parameters="filterParameters"
      @input="changeFilters"
      :all-props="allProps"
      v-bind="$attrs"
    >
      <template #append="scope">
        <slot name="append" v-bind="scope" />
      </template>
    </search-filter>
  </resource-loader-controller>
</template>

<script setup lang="ts">
import SearchFilter from './FilterView.vue'

defineOptions({
  inheritAttrs: false,
})
const props = defineProps<{
  filters?: any
  listResource: any
  permanent?: any
  filterParameters?: any
}>()

const emit = defineEmits<{
  'update:filters': [v: any]
}>()

function changeFilters(value: any) {
  emit('update:filters', value);
}
</script>
